import React, { FC } from "react";
import { redirectKeyPressToClick } from "../../../../helpers/interactionHandlers";
import { StyledAnchor, StyledImg, StyledLogo } from "./index.styled";

export interface LogoProps {
  customWidthOnMobile?: number;
  leftAlignOnMobile?: boolean;
  logoImgLink: string;
  logoUrl?: string;
  onClickHandler?: React.MouseEventHandler;
}

export const Logo: FC<{ logo: LogoProps }> = ({ logo }) => {
  const {
    customWidthOnMobile,
    leftAlignOnMobile,
    logoImgLink,
    logoUrl,
    onClickHandler,
  } = logo;

  if (logoUrl && !onClickHandler) {
    return (
      <StyledLogo
        customWidthOnMobile={customWidthOnMobile}
        leftAlignOnMobile={leftAlignOnMobile}
      >
        <StyledAnchor tabIndex={0} href={logoUrl}>
          <StyledImg
            alt="Brand logo"
            customWidthOnMobile={customWidthOnMobile}
            leftAlignOnMobile={leftAlignOnMobile}
            src={logoImgLink}
          />
        </StyledAnchor>
      </StyledLogo>
    );
  } else if (!logoUrl && onClickHandler) {
    return (
      <StyledLogo
        customWidthOnMobile={customWidthOnMobile}
        leftAlignOnMobile={leftAlignOnMobile}
      >
        <StyledImg
          alt="Brand logo"
          clickable
          customWidthOnMobile={customWidthOnMobile}
          leftAlignOnMobile={leftAlignOnMobile}
          onClick={onClickHandler}
          onKeyDown={redirectKeyPressToClick}
          src={logoImgLink}
          tabIndex={0}
        />
      </StyledLogo>
    );
  } else if (!logoUrl && !onClickHandler) {
    // no interaction on the logo; just display the image
    return (
      <StyledLogo
        customWidthOnMobile={customWidthOnMobile}
        leftAlignOnMobile={leftAlignOnMobile}
      >
        <StyledImg
          alt="Brand logo"
          customWidthOnMobile={customWidthOnMobile}
          leftAlignOnMobile={leftAlignOnMobile}
          src={logoImgLink}
        />
      </StyledLogo>
    );
  } else {
    // both logoUrl and onClickHandler provided
    return (
      <StyledLogo
        customWidthOnMobile={customWidthOnMobile}
        leftAlignOnMobile={leftAlignOnMobile}
        onClick={onClickHandler}
      >
        <StyledAnchor href={logoUrl}>
          <StyledImg
            alt="Brand logo"
            customWidthOnMobile={customWidthOnMobile}
            leftAlignOnMobile={leftAlignOnMobile}
            src={logoImgLink}
          />
        </StyledAnchor>
      </StyledLogo>
    );
  }
};
